document.addEventListener("DOMContentLoaded", function () {

    const overlay = document.getElementById("coldcuts-overlay");
    const input = document.getElementById("coldcuts-pin");
    const button = document.getElementById("coldcuts-check");

    const success = document.getElementById("coldcuts-success");
    const error = document.getElementById("coldcuts-error");
    const removeBtn = document.getElementById("coldcuts-remove-btn");
    const closeBtnText = document.getElementById("coldcuts-close-btn");

    function verifyPin(pin) {
        return window.coldCutsAllowedPins && window.coldCutsAllowedPins.includes(pin);
    }

    function checkMinCartValue() {
        const minVal = 55500; // ₹555.00 in cents/paise
        const warningId = "min-cart-warning";
        
        const container = document.querySelector('[data-cart-total]');
        const rawPriceAttr = container ? container.getAttribute('data-cart-total') : null;
        let currentPrice = rawPriceAttr ? parseInt(rawPriceAttr) : window.cartTotalPrice;
        

        
        const hasColdCutsAttr = container ? container.getAttribute('data-has-coldcuts') : null;
        const coldCutsKeysAttr = container ? container.getAttribute('data-coldcuts-keys') : null;
        
        if (hasColdCutsAttr !== null) {
            window.cartHasColdCuts = (hasColdCutsAttr === "true");
        }
        if (coldCutsKeysAttr !== null) {
            window.cartColdCutsKeys = coldCutsKeysAttr ? coldCutsKeysAttr.split(",") : [];
        }
        
        let warnings = document.querySelectorAll('.' + warningId);
        
        if (currentPrice !== undefined && currentPrice > 0 && currentPrice < minVal) {
            // Disable checkout buttons
            document.querySelectorAll('[name="checkout"], .shopify-payment-button, .shopify-payment-button__button, .btn-checkout-dynamic').forEach(btn => {
                if (!btn.disabled || !btn.classList.contains("coldcuts-disabled") || btn.getAttribute("title") !== "Minimum order value is ₹555.") {
                    btn.disabled = true;
                    btn.classList.add("coldcuts-disabled");
                    btn.setAttribute("title", "Minimum order value is ₹555.");
                }
            });
            
            // Render warning messages in correct positions
            const isMinicart = document.querySelector('#minicart_wrapper');
            
            if (isMinicart) {
                // For minicart, place below progress bar
                const progressBar = document.querySelector('#minicart_wrapper free-ship-progress-bar');
                if (progressBar) {
                    if (!document.querySelector('#minicart_wrapper .' + warningId)) {
                        const warning = document.createElement("div");
                        warning.className = warningId;
                        warning.style.color = "#d0473e";
                        warning.style.fontSize = "13px";
                        warning.style.fontWeight = "600";
                        warning.style.padding = "10px 5px";
                        warning.style.backgroundColor = "#fff5f5";
                        warning.style.borderBottom = "1px solid #ffe3e3";
                        warning.style.textAlign = "center";
                        warning.innerHTML = "Minimum order value is ₹555. Please add more items to checkout.";
                        progressBar.after(warning);
                    }
                } else {
                    // Fallback to minicart header
                    const header = document.querySelector('.minicart__header');
                    if (header && !document.querySelector('#minicart_wrapper .' + warningId)) {
                        const warning = document.createElement("div");
                        warning.className = warningId;
                        warning.style.color = "#d0473e";
                        warning.style.fontSize = "13px";
                        warning.style.fontWeight = "600";
                        warning.style.padding = "10px 5px";
                        warning.style.backgroundColor = "#fff5f5";
                        warning.style.borderBottom = "1px solid #ffe3e3";
                        warning.style.textAlign = "center";
                        warning.innerHTML = "Minimum order value is ₹555. Please add more items to checkout.";
                        header.after(warning);
                    }
                }
            }
            
            // For main cart page checkout button
            document.querySelectorAll('.cart__ctas [name="checkout"], .cart-summary [name="checkout"]').forEach(btn => {
                if (btn.closest('#minicart_wrapper')) return;
                const parent = btn.parentElement;
                if (parent && !parent.querySelector('.' + warningId)) {
                    const warning = document.createElement("div");
                    warning.className = warningId;
                    warning.style.color = "#d0473e";
                    warning.style.fontSize = "13px";
                    warning.style.fontWeight = "600";
                    warning.style.marginTop = "10px";
                    warning.style.marginBottom = "10px";
                    warning.style.width = "100%";
                    warning.style.textAlign = "center";
                    warning.innerHTML = "Minimum order value is ₹555. Please add more items to checkout.";
                    btn.before(warning);
                }
            });
        } else {
            warnings.forEach(w => w.remove());
            
            const v = localStorage.getItem("coldcuts_verified");
            const sp = localStorage.getItem("coldcuts_pin");
            const ipv = sp && verifyPin(sp);
            const pinValidationFails = window.cartHasColdCuts && (v !== "true" || !ipv);
            
            if (!pinValidationFails) {
                document.querySelectorAll('[name="checkout"], .shopify-payment-button, .shopify-payment-button__button, .btn-checkout-dynamic').forEach(btn => {
                    if (btn.getAttribute("title") === "Minimum order value is ₹555.") {
                        if (btn.disabled || btn.classList.contains("coldcuts-disabled") || btn.hasAttribute("title")) {
                            btn.disabled = false;
                            btn.classList.remove("coldcuts-disabled");
                            btn.removeAttribute("title");
                        }
                    }
                });
            }
        }
    }

    // Run checks globally on load
    checkMinCartValue();

    function isRestricted() {
        return window.coldCutsProduct ||
               window.coldCutsCollection ||
               window.cartHasColdCuts;
    }

    function getAddCartButtons() {
        return document.querySelectorAll(
            'form[action="/cart/add"] button,[name="add"]'
        );
    }

    function disableCart() {
        getAddCartButtons().forEach(btn => {
            if (!btn.disabled || !btn.classList.contains("coldcuts-disabled")) {
                btn.disabled = true;
                btn.classList.add("coldcuts-disabled");
            }
        });
    }

    function enableCart() {
        getAddCartButtons().forEach(btn => {
            if (btn.disabled || btn.classList.contains("coldcuts-disabled")) {
                btn.disabled = false;
                btn.classList.remove("coldcuts-disabled");
            }
        });
    }

    function getCheckoutButtons() {
        return document.querySelectorAll('[name="checkout"], .shopify-payment-button, .shopify-payment-button__button, .btn-checkout-dynamic');
    }

    function disableCheckout() {
        getCheckoutButtons().forEach(btn => {
            if (!btn.disabled || !btn.classList.contains("coldcuts-disabled") || btn.getAttribute("title") !== "Please verify a serviceable PIN code to checkout.") {
                btn.disabled = true;
                btn.classList.add("coldcuts-disabled");
                btn.setAttribute("title", "Please verify a serviceable PIN code to checkout.");
            }
        });
    }

    function enableCheckout() {
        getCheckoutButtons().forEach(btn => {
            if (btn.disabled || btn.classList.contains("coldcuts-disabled") || btn.hasAttribute("title")) {
                btn.disabled = false;
                btn.classList.remove("coldcuts-disabled");
                btn.removeAttribute("title");
            }
        });
    }

    if (isRestricted()) {
        // Run initial checks on load
        const verified = localStorage.getItem("coldcuts_verified");
        const storedPin = localStorage.getItem("coldcuts_pin");
        const isPinValid = storedPin && verifyPin(storedPin);

        if (verified === "true" && isPinValid) {
            enableCart();
            enableCheckout();
        } else {
            disableCart();
            if (window.cartHasColdCuts) {
                disableCheckout();
                if (overlay) overlay.classList.add("active");
                if (removeBtn) removeBtn.style.display = "block";
                
                if (storedPin && !isPinValid && input && error) {
                    input.value = storedPin;
                    error.innerHTML = "Fresh Cold Cuts are available only in Siliguri and its local areas. Please remove the Cold Cut products from your cart to proceed.";
                    error.style.display = "block";
                }
            } else {
                if (overlay) overlay.classList.add("active");
            }
        }

        // Intercept clicks on checkout buttons if cart has coldcuts and pin is invalid
        document.addEventListener("click", function (e) {
            if (e.target.closest('[name="checkout"], .shopify-payment-button, .shopify-payment-button__button, .btn-checkout-dynamic')) {
                const v = localStorage.getItem("coldcuts_verified");
                const sp = localStorage.getItem("coldcuts_pin");
                const ipv = sp && verifyPin(sp);
                if (window.cartHasColdCuts && (v !== "true" || !ipv)) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (overlay) overlay.classList.add("active");
                    disableCheckout();
                }
            }
        }, true);

        if (button) {
            button.addEventListener("click", function () {
                if (success) success.style.display = "none";
                if (error) error.style.display = "none";
                if (removeBtn) removeBtn.style.display = "none";
                if (closeBtnText) closeBtnText.style.display = "none";

                const pin = input ? input.value.trim() : "";

                if (pin.length !== 6) {
                    if (error) {
                        error.innerHTML = "Please enter a valid 6 digit PIN Code.";
                        error.style.display = "block";
                    }
                    return;
                }

                if (verifyPin(pin)) {
                    localStorage.setItem("coldcuts_verified", "true");
                    localStorage.setItem("coldcuts_pin", pin);

                    if (success) success.style.display = "block";

                    enableCart();
                    enableCheckout();

                    setTimeout(function(){
                        if (overlay) overlay.classList.remove("active");
                    }, 800);

                } else {
                    if (error) {
                        if (window.cartHasColdCuts) {
                            error.innerHTML = "Fresh Cold Cuts are available only in Siliguri and its local areas. Please remove the Cold Cut products from your cart to proceed.";
                            if (removeBtn) removeBtn.style.display = "block";
                        } else {
                            error.innerHTML = "Fresh Cold Cuts are available only in Siliguri and its local areas.";
                            if (closeBtnText) closeBtnText.style.display = "block";
                        }
                        error.style.display = "block";
                    }
                    disableCart();
                    disableCheckout();
                }
            });
        }

        if (removeBtn) {
            removeBtn.addEventListener("click", function () {
                removeBtn.disabled = true;
                removeBtn.innerText = "Removing...";

                const updates = {};
                if (window.cartColdCutsKeys && window.cartColdCutsKeys.length > 0) {
                    window.cartColdCutsKeys.forEach(key => {
                        if (key) {
                            updates[key] = 0;
                        }
                    });
                }

                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: updates })
                }).then(res => res.json())
                  .then(cart => {
                      localStorage.removeItem("coldcuts_verified");
                      localStorage.removeItem("coldcuts_pin");
                      window.location.reload();
                  }).catch(err => {
                      console.error("Failed to update cart", err);
                      removeBtn.disabled = false;
                      removeBtn.innerText = "Remove Cold Cuts & Continue Browsing";
                  });
            });
        }

        if (closeBtnText) {
            closeBtnText.addEventListener("click", function () {
                if (overlay) overlay.classList.remove("active");
            });
        }
    }

    // Watch for dynamic changes (like variant selection or cart renders) to keep restrictions applied
    const observer = new MutationObserver(function() {


        // Run min cart check dynamically on change
        checkMinCartValue();

        if (isRestricted()) {
            const v = localStorage.getItem("coldcuts_verified");
            const sp = localStorage.getItem("coldcuts_pin");
            const ipv = sp && verifyPin(sp);
            const isVerified = (v === "true" && ipv);

            if (!isVerified) {
                if (window.coldCutsProduct || window.coldCutsCollection) {
                    disableCart();
                }
                if (window.cartHasColdCuts) {
                    disableCheckout();
                }
            } else {
                enableCart();
                // Enable checkout only if minimum cart check is not blocking it
                const minVal = 55500;
                const container = document.querySelector('[data-cart-total]');
                const rawPriceAttr = container ? container.getAttribute('data-cart-total') : null;
                const currentPrice = rawPriceAttr ? parseInt(rawPriceAttr) : window.cartTotalPrice;
                if (!(currentPrice !== undefined && currentPrice > 0 && currentPrice < minVal)) {
                    enableCheckout();
                }
            }
        } else {
            // If not restricted at all, ensure buttons are enabled
            enableCart();
            const minVal = 55500;
            const container = document.querySelector('[data-cart-total]');
            const rawPriceAttr = container ? container.getAttribute('data-cart-total') : null;
            const currentPrice = rawPriceAttr ? parseInt(rawPriceAttr) : window.cartTotalPrice;
            if (!(currentPrice !== undefined && currentPrice > 0 && currentPrice < minVal)) {
                enableCheckout();
            }
        }
    });
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'class']
    });

    const closeBtn = document.getElementById("coldcuts-close");
    closeBtn?.addEventListener("click", () => {
        const overlay = document.getElementById("coldcuts-overlay");
        overlay?.classList.remove("active");
    });

});